import moment from 'moment';

const eventTimer = (start: string, end: string, now: string) => {
  const n = moment(now);
  const s = moment(start);
  const e = moment(end);

  return n.isBetween(s, e);
};

export default eventTimer;
